/**
 * Belgian date formatting for the statistics screen. The backend always returns ISO
 * (YYYY-MM-DD, YYYY-MM-DD HH:MM:SS, YYYY-MM); these helpers turn every occurrence inside
 * a string into DD/MM/YYYY, DD/MM/YYYY HH:MM or MM/YYYY, so texts such as
 * "Geldig tot 2026-07-01" or "2026-05-01 → 2026-06-04" are covered as well.
 */
const DATETIME = /\b(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2})(?::\d{2})?)?\b/g;
const MONTH = /\b(\d{4})-(\d{2})\b(?!-)/g;

/** Replaces every ISO date / datetime / month in a string. Non-strings come back untouched. */
export function belgianDates(value) {
  if (typeof value !== 'string' || !/\d{4}-\d{2}/.test(value)) return value;
  return value
    .replace(DATETIME, (m, y, mo, d, h, mi) => (h ? `${d}/${mo}/${y} ${h}:${mi}` : `${d}/${mo}/${y}`))
    .replace(MONTH, (m, y, mo) => `${mo}/${y}`);
}

/** Short axis label: DD/MM for a day, MM/YYYY for a month. */
export function axisDate(value) {
  const s = String(value || '');
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) return `${s.slice(8, 10)}/${s.slice(5, 7)}`;
  if (/^\d{4}-\d{2}$/.test(s)) return `${s.slice(5, 7)}/${s.slice(0, 4)}`;
  if (/^\d{6}$/.test(s)) return `${s.slice(4, 6)}/${s.slice(0, 4)}`; // yearmonth 202605
  return s;
}
